const actionTypes = {
  GET_HEARTBEAT_REQUEST: 'culture/GET_HEARTBEAT',
  GET_HEARTBEAT_SUCCESS: 'culture/GET_HEARTBEAT_SUCCESS',
  GET_HEARTBEAT_ERROR: 'culture/GET_HEARTBEAT_ERROR',
} as const;

export default actionTypes;
